/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyFormRoleFormsInner
 */
export interface CompanyFormRoleFormsInner {
    /**
     * 
     * @type {string}
     * @memberof CompanyFormRoleFormsInner
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyFormRoleFormsInner
     */
    form?: string | null;
}

/**
 * Check if a given object implements the CompanyFormRoleFormsInner interface.
 */
export function instanceOfCompanyFormRoleFormsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyFormRoleFormsInnerFromJSON(json: any): CompanyFormRoleFormsInner {
    return CompanyFormRoleFormsInnerFromJSONTyped(json, false);
}

export function CompanyFormRoleFormsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyFormRoleFormsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'form': !exists(json, 'form') ? undefined : json['form'],
    };
}

export function CompanyFormRoleFormsInnerToJSON(value?: CompanyFormRoleFormsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form': value.form,
    };
}

